import EditCompany from "./editCompany";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
};

const EditCompanyModal = ({ toggleModal, urlTittle }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={`Editar Información de la empresa`}
        titleStyle={styles}
        urlTittle={urlTittle}
      >
        <EditCompany />
      </Modal>
    </>
  );
};

export default EditCompanyModal;
